// extracted by mini-css-extract-plugin
export default {"container":"OutletCard_container__JBzGA","selected":"OutletCard_selected__gCENK","outletInfo":"OutletCard_outletInfo__vIfZd"};